import { Controller } from 'react-hook-form';
import SelectAutocomplete from '../../inputs/select/autocomplete/select-autocomplete';
import { FormProps } from '../../../shared/interfaces/form';
import { useState, useEffect } from 'react';

interface FormSelectProps {
  item: FormProps;
  index: number;
  baseId: string;
  errors: any;
  control: any;
  isDisabled: boolean;
  setValue: (name: string, value: any) => void;
  getValues: (name?: string | string[]) => any;
}

const FormSelect = ({
  item,
  index,
  baseId,
  errors,
  control,
  isDisabled,
  setValue,
  getValues
}: FormSelectProps) => {
  const [ isDisabledSelect, setIsDisabledSelect ] = useState(false);
  
  const handleSelectChange = (newValue: any, onChange: any) => {
    onChange(newValue);
    
    if (item.name === 'idTipoLancamento') {
    }
  };
  
  useEffect(() => {
    const page = window.location.hash.split('/')[1];

    if(page.toLocaleLowerCase().includes('list')) {
      setIsDisabledSelect(true);
    }

  }, [isDisabled]);


  return (
    <Controller
      key={`select-${index}-${baseId}`}
      name={item.name}
      control={control}
      defaultValue={item.value}
      rules={item.rules}
      render={({ field }) => (
        <SelectAutocomplete
          placeholder={item.placeholder} 
          error={errors[item.name]?.message}
          data={item.options?.data || []}
          value={field.value}
          onChange={(newValue) => handleSelectChange(newValue, field.onChange)}
          disabled={isDisabled || isDisabledSelect}
        />
      )}
    />
  );
};

export default FormSelect;